"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSelectErrorOption = exports.isGranteeItem = exports.isGranteeGroupAll = exports.isGranteeGroup = exports.isGranteeUserInactive = exports.isGranteeUser = void 0;
var tslib_1 = require("tslib");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
/**
 * @internal
 */
exports.isGranteeUser = function (obj) {
    return !isEmpty_1.default(obj) && obj.type === "user";
};
/**
 * @internal
 */
exports.isGranteeUserInactive = function (obj) {
    return !isEmpty_1.default(obj) && obj.type === "inactive_owner";
};
/**
 * @internal
 */
exports.isGranteeGroup = function (obj) {
    return !isEmpty_1.default(obj) && obj.type === "group";
};
/**
 * @internal
 */
exports.isGranteeGroupAll = function (obj) {
    return !isEmpty_1.default(obj) && obj.type === "groupAll";
};
/**
 * @internal
 */
exports.isGranteeItem = function (obj) {
    return (!isEmpty_1.default(obj) &&
        (exports.isGranteeGroupAll(obj) || exports.isGranteeGroup(obj) || exports.isGranteeUserInactive(obj) || exports.isGranteeUser(obj)));
};
/**
 * @internal
 */
exports.isSelectErrorOption = function (obj) {
    return !isEmpty_1.default(obj) && obj.type === "error";
};
//# sourceMappingURL=types.js.map